module.exports = __webpack_public_path__ + "img/survey-pattern-top.2cb350e2.png";